import {
  MIN_BAR_WIDTH_PERCENT,
  OPEN_ENDED_STRIPE_PX,
  STATUS_TO_BAR_PALETTE,
} from './RunTimeline.constants';

const LABEL_WIDTH = 200;
const TRACK_HEIGHT = 14;

export const timelineStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  paddingX: 2,
  paddingY: 1,
  borderRadius: 2,
  border: `1px solid ${palette.divider}`,
  backgroundColor: palette.background.paper,
});

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  minWidth: 0,
};

export const tracksStyles = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
  flex: 1,
  minWidth: 0,
};

export const trackStyles = ({ palette }) => ({
  position: 'relative',
  height: TRACK_HEIGHT,
  borderRadius: 999,
  backgroundColor: palette.action.hover,
});

const getOpenEndedFill = color =>
  `repeating-linear-gradient(135deg, ${color} 0 ${OPEN_ENDED_STRIPE_PX}px, transparent ${OPEN_ENDED_STRIPE_PX}px ${OPEN_ENDED_STRIPE_PX * 2}px)`;

export const getBarStyles =
  ({ status, leftPercent, widthPercent, isOpenEnded }) =>
  ({ palette }) => {
    const color = palette[STATUS_TO_BAR_PALETTE[status]]?.main ?? palette.text.disabled;

    return {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: `${leftPercent}%`,
      width: `${Math.max(widthPercent, MIN_BAR_WIDTH_PERCENT)}%`,
      borderRadius: 999,
      ...(isOpenEnded
        ? { backgroundImage: getOpenEndedFill(color), border: `1px solid ${color}` }
        : { backgroundColor: color }),
    };
  };

export const getNowMarkerStyles =
  nowPercent =>
  ({ palette }) => ({
    position: 'absolute',
    top: -4,
    bottom: -4,
    left: `${nowPercent}%`,
    width: 2,
    backgroundColor: palette.error.main,
    pointerEvents: 'none',
  });

export const trackAreaStyles = {
  display: 'flex',
  gap: 1.5,
};

export const labelsColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
  flexShrink: 0,
  width: LABEL_WIDTH,
};

export const labelCellStyles = ({ palette }) => ({
  height: TRACK_HEIGHT,
  lineHeight: `${TRACK_HEIGHT}px`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: palette.text.primary,
});

export const summaryStyles = ({ palette }) => ({
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: palette.text.secondary,
});
